import { render, staticRenderFns } from "./AddStation.vue?vue&type=template&id=bbf5c418&scoped=true&"
import script from "./AddStation.vue?vue&type=script&lang=js&"
export * from "./AddStation.vue?vue&type=script&lang=js&"
import style0 from "./AddStation.vue?vue&type=style&index=0&id=bbf5c418&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf5c418",
  null
  
)

export default component.exports